import { RejectedUserRptService } from '../services';
import { RejectedUserRptConstants } from '../constants';
import { alertActions } from '.';

export const RejectedUserRptAction = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());
       RejectedUserRptService.fetchRejectedUserData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function request() { return { type: RejectedUserRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: RejectedUserRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: RejectedUserRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: RejectedUserRptConstants.GETALL_FAILURE, error } }
}
function exportData(obj) {
    return dispatch => {
        dispatch(request());
        RejectedUserRptService.fetchRejectedUserData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { 
                    delete v.TotalRows; 
                    delete v.UserId; 
                    delete v.QRDamageImg; 
                });
            }            
            dispatch(success(data));
        },        
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        });
    };

    function request() { return { type: RejectedUserRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: RejectedUserRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: RejectedUserRptConstants.GETEXPORT_FAILURE, error } }
}


function loadingData(isbool) {
    return {
        type: RejectedUserRptConstants.LOADING_REQUEST, isbool
    }
}
